/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Ch_3_DInputs */

const en_cp_ch_3_d = /** @type {(inputs: Cp_Ch_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builders: real users and transactions. Solvers: handover and the problem owner's success metric.`)
};

const id_cp_ch_3_d = /** @type {(inputs: Cp_Ch_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builder: pengguna dan transaksi nyata. Solver: serah terima dan ukuran keberhasilan pemilik masalah.`)
};

/**
* | output |
* | --- |
* | "Builders: real users and transactions. Solvers: handover and the problem owner's success metric." |
*
* @param {Cp_Ch_3_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_ch_3_d = /** @type {((inputs?: Cp_Ch_3_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Ch_3_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_ch_3_d(inputs)
	return en_cp_ch_3_d(inputs)
});